import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AboutHero from "../components/AboutHero";
import AboutDetails from "../components/AboutDetails";
import SeoHead from "../components/seo/SeoHead";
import Waves from "../blocks/Backgrounds/Waves/Waves";
import SkillsSection from "../components/SkillsSection"; // Nuevo componente
import ContactInfo from "../components/ContactInfo";
import GradientText from "../blocks/GradientText/GradientText";
import TextPressure from "../blocks/TextPressure/TextPressure";
import AboutVideoMission from "../components/videos/AboutVideoMission";
import RotatingText from "../blocks/RotatingText/RotatingText";
import TimelineComponent from "../components/timeline/TimelineComponent";
import { useTranslation } from "../i18n";
import { renderBrandText } from "../utils/brandText";
import "./About.css";

// Contenido sincronizado con el RotatingText
const textData = {
    compromiso: (
        <>
            <p>
                <strong>Mi compromiso</strong> con <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> es proporcionar contenido de calidad para cualquier persona, sin importar su experiencia, ayudándola a dominar el <strong>testing de software</strong>.
            </p>
            <p>En esta plataforma nuestro compromiso se basa en:</p>
            <p><strong>Brindar educación accesible</strong>: Mediante tutoriales, cursos y contenido gratuito en diversas plataformas.</p>
            <p><strong>Enseñar con enfoque práctico</strong>: Aplicando conceptos reales, herramientas modernas y desafíos cotidianos.</p>
            <p><strong>Construir una comunidad</strong>: Donde testers de todo el mundo compartan conocimientos y experiencias.</p>
            <p><strong>Promover las mejores prácticas</strong>: Elevando el estándar del testing y ayudando a testers a destacarse profesionalmente.</p>
            <p>
                Mi objetivo es hacer de <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> un referente en <strong>Quality Assurance</strong>, guiando a más personas hacia el éxito en este mundo.
            </p>
        </>
    ),
    mision: (
        <>
            <p>
                <strong>Mi misión</strong> con <span className="theqahub-font">{"</"}TheQAHub{">"}</span> es capacitar a testers, nuevos y experimentados, para que dominen el <strong>Quality Assurance</strong> a través de formación accesible y práctica.
            </p>
            <p><strong>Fomentar la excelencia</strong>: Con contenido detallado y aplicado a situaciones reales de la industria.</p>
            <p><strong>Impulsar carreras</strong>: Brindando herramientas para mejorar habilidades técnicas y acceder a más oportunidades.</p>
            <p><strong>Crear una comunidad global</strong>: Un espacio donde testers puedan compartir conocimiento y resolver dudas juntos.</p>
            <p><strong>Innovar constantemente</strong>: Manteniéndonos a la vanguardia en automatización y estrategias QA.</p>
            <p>{renderBrandText("TheQAHub es un espacio de crecimiento, donde cada tester puede aprender, conectar y mejorar su impacto en la industria del software.")}</p>
        </>
    ),
    vision: (
        <>
            <p>
                <strong>Mi visión</strong> es convertir <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> en la referencia principal para aprender <strong>QA</strong> en español.
            </p>
            <p>Visualizo un ecosistema donde cualquier persona interesada en <strong>Quality Assurance</strong> pueda:</p>
            <p>Aprender desde cero con contenido estructurado y actualizado.</p>
            <p>Conectar con una comunidad de testers apasionados por la calidad del software.</p>
            <p>Tener acceso a oportunidades laborales y networking en la industria del QA.</p>
            <p><strong>Ampliar el alcance</strong>: Creando herramientas que faciliten el aprendizaje del testing manual y automatizado.</p>
            <p>{renderBrandText("TheQAHub no es solo una plataforma de enseñanza, es una comunidad en constante evolución, donde el conocimiento y la innovación van de la mano.")}</p>
        </>
    ),
};

const textDataMobile = {
    meta: (
        <>
            <p>
                <strong>Mi meta</strong> con <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> es proporcionar contenido de calidad para cualquier persona, sin importar su experiencia, ayudándola a dominar el <strong>testing de software</strong>.
            </p>
            <p>En esta plataforma nuestro compromiso se basa en:</p>
            <p><strong>Brindar educación accesible</strong>: Mediante tutoriales, cursos y contenido gratuito en diversas plataformas.</p>
            <p><strong>Enseñar con enfoque práctico</strong>: Aplicando conceptos reales, herramientas modernas y desafíos cotidianos.</p>
            <p><strong>Construir una comunidad</strong>: Donde testers de todo el mundo compartan conocimientos y experiencias.</p>
            <p><strong>Promover las mejores prácticas</strong>: Elevando el estándar del testing y ayudando a testers a destacarse profesionalmente.</p>
            <p>
                Mi objetivo es hacer de <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> un referente en <strong>Quality Assurance</strong>, guiando a más personas hacia el éxito en este mundo.
            </p>
        </>
    ),
    mision: (
        <>
            <p>
                <strong>Mi misión</strong> con <span className="theqahub-font">{"</"}TheQAHub{">"}</span> es capacitar a testers, nuevos y experimentados, para que dominen el <strong>Quality Assurance</strong> a través de formación accesible y práctica.
            </p>
            <p><strong>Fomentar la excelencia</strong>: Con contenido detallado y aplicado a situaciones reales de la industria.</p>
            <p><strong>Impulsar carreras</strong>: Brindando herramientas para mejorar habilidades técnicas y acceder a más oportunidades.</p>
            <p><strong>Crear una comunidad global</strong>: Un espacio donde testers puedan compartir conocimiento y resolver dudas juntos.</p>
            <p><strong>Innovar constantemente</strong>: Manteniéndonos a la vanguardia en automatización y estrategias QA.</p>
            <p>{renderBrandText("TheQAHub es un espacio de crecimiento, donde cada tester puede aprender, conectar y mejorar su impacto en la industria del software.")}</p>
        </>
    ),
    vision: (
        <>
            <p>
                <strong>Mi visión</strong> es convertir <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> en la referencia principal para aprender <strong>QA</strong> en español.
            </p>
            <p>Visualizo un ecosistema donde cualquier persona interesada en <strong>Quality Assurance</strong> pueda:</p>
            <p>Aprender desde cero con contenido estructurado y actualizado.</p>
            <p>Conectar con una comunidad de testers apasionados por la calidad del software.</p>
            <p>Tener acceso a oportunidades laborales y networking en la industria del QA.</p>
            <p><strong>Ampliar el alcance</strong>: Creando herramientas que faciliten el aprendizaje del testing manual y automatizado.</p>
            <p>{renderBrandText("TheQAHub no es solo una plataforma de enseñanza, es una comunidad en constante evolución, donde el conocimiento y la innovación van de la mano.")}</p>
        </>
    ),
};

const textDataEn = {
    compromiso: (
        <>
            <p><strong>My commitment</strong> to <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> is to provide quality content for anyone, regardless of their experience, helping them master <strong>software testing</strong>.</p>
            <p>On this platform, that commitment is built around:</p>
            <p><strong>Accessible education</strong>: Through tutorials, courses and free content across different platforms.</p>
            <p><strong>Practical learning</strong>: Applying real concepts, modern tools and everyday challenges.</p>
            <p><strong>Building a community</strong>: A space where testers from around the world can share knowledge and experiences.</p>
            <p><strong>Promoting best practices</strong>: Raising the standard of testing and helping testers stand out professionally.</p>
            <p>My goal is to make <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> a reference point in <strong>Quality Assurance</strong>, guiding more people toward success in this field.</p>
        </>
    ),
    mision: (
        <>
            <p><strong>My mission</strong> with <span className="theqahub-font">{"</"}TheQAHub{">"}</span> is to help new and experienced testers master <strong>Quality Assurance</strong> through accessible and practical training.</p>
            <p><strong>Encouraging excellence</strong>: With detailed content applied to real industry situations.</p>
            <p><strong>Boosting careers</strong>: Providing tools to improve technical skills and access more opportunities.</p>
            <p><strong>Creating a global community</strong>: A space where testers can share knowledge and solve doubts together.</p>
            <p><strong>Innovating constantly</strong>: Staying up to date with automation and QA strategies.</p>
            <p>{renderBrandText("TheQAHub is a growth space where every tester can learn, connect and improve their impact in the software industry.")}</p>
        </>
    ),
    vision: (
        <>
            <p><strong>My vision</strong> is to turn <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> into a leading reference for learning <strong>QA</strong>.</p>
            <p>I imagine an ecosystem where anyone interested in <strong>Quality Assurance</strong> can:</p>
            <p>Learn from scratch with structured and updated content.</p>
            <p>Connect with a community of testers passionate about software quality.</p>
            <p>Access career opportunities and networking in the QA industry.</p>
            <p><strong>Expand the reach</strong>: Creating tools that make manual and automated testing easier to learn.</p>
            <p>{renderBrandText("TheQAHub is not just a learning platform; it is an evolving community where knowledge and innovation go hand in hand.")}</p>
        </>
    ),
};

const textDataEnMobile = {
    meta: textDataEn.compromiso,
    mision: textDataEn.mision,
    vision: textDataEn.vision,
};

const textDataDe = {
    compromiso: (
        <>
            <p><strong>Mein Engagement</strong> fur <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> ist es, hochwertige Inhalte fur alle bereitzustellen, unabhangig von ihrer Erfahrung, und ihnen zu helfen, <strong>Softwaretesting</strong> zu meistern.</p>
            <p>Auf dieser Plattform basiert dieses Engagement auf:</p>
            <p><strong>Zuganglicher Bildung</strong>: Durch Tutorials, Kurse und kostenlose Inhalte auf verschiedenen Plattformen.</p>
            <p><strong>Praxisnahem Lernen</strong>: Mit realen Konzepten, modernen Tools und alltaglichen Herausforderungen.</p>
            <p><strong>Community-Aufbau</strong>: Ein Ort, an dem Tester weltweit Wissen und Erfahrungen teilen konnen.</p>
            <p><strong>Best Practices fordern</strong>: Den Testing-Standard anheben und Testern helfen, beruflich herauszustechen.</p>
            <p>Mein Ziel ist es, <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> zu einer Referenz fur <strong>Quality Assurance</strong> zu machen und mehr Menschen in diesem Bereich zum Erfolg zu begleiten.</p>
        </>
    ),
    mision: (
        <>
            <p><strong>Meine Mission</strong> mit <span className="theqahub-font">{"</"}TheQAHub{">"}</span> ist es, neue und erfahrene Tester dabei zu unterstutzen, <strong>Quality Assurance</strong> durch zugangliche und praktische Weiterbildung zu meistern.</p>
            <p><strong>Exzellenz fordern</strong>: Mit detaillierten Inhalten, die auf reale Situationen der Branche angewendet werden.</p>
            <p><strong>Karrieren starken</strong>: Mit Werkzeugen, um technische Fahigkeiten zu verbessern und neue Chancen zu erschliessen.</p>
            <p><strong>Eine globale Community schaffen</strong>: Ein Ort, an dem Tester Wissen teilen und Fragen gemeinsam losen konnen.</p>
            <p><strong>Standig innovieren</strong>: Immer auf dem neuesten Stand bei Automatisierung und QA-Strategien bleiben.</p>
            <p>{renderBrandText("TheQAHub ist ein Wachstumsraum, in dem jeder Tester lernen, sich vernetzen und seinen Einfluss in der Softwarebranche verbessern kann.")}</p>
        </>
    ),
    vision: (
        <>
            <p><strong>Meine Vision</strong> ist es, <strong><span className="theqahub-font">{"</"}TheQAHub{">"}</span></strong> zu einer wichtigen Referenz fur das Lernen von <strong>QA</strong> zu machen.</p>
            <p>Ich stelle mir ein Okosystem vor, in dem jede Person mit Interesse an <strong>Quality Assurance</strong>:</p>
            <p>Von Grund auf mit strukturierten und aktuellen Inhalten lernen kann.</p>
            <p>Sich mit einer Community von Testern verbinden kann, die Softwarequalitat lieben.</p>
            <p>Zugang zu beruflichen Chancen und Networking in der QA-Branche bekommt.</p>
            <p><strong>Die Reichweite erweitern</strong>: Tools schaffen, die das Lernen von manuellem und automatisiertem Testing erleichtern.</p>
            <p>{renderBrandText("TheQAHub ist nicht nur eine Lernplattform, sondern eine Community in standiger Entwicklung, in der Wissen und Innovation zusammengehen.")}</p>
        </>
    ),
};

const textDataDeMobile = {
    meta: textDataDe.compromiso,
    mision: textDataDe.mision,
    vision: textDataDe.vision,
};

const missionCopy = {
    es: {
        desktop: textData,
        mobile: textDataMobile,
        desktopLabels: ["compromiso", "misión", "visión"],
        mobileLabels: ["meta", "misión", "visión"],
        prefix: "Mi",
        suffix: "con",
    },
    en: {
        desktop: textDataEn,
        mobile: textDataEnMobile,
        desktopLabels: ["commitment", "mission", "vision"],
        mobileLabels: ["goal", "mission", "vision"],
        prefix: "My",
        suffix: "with",
    },
    de: {
        desktop: textDataDe,
        mobile: textDataDeMobile,
        desktopLabels: ["Engagement", "Mission", "Vision"],
        mobileLabels: ["Ziel", "Mission", "Vision"],
        prefix: "Mein",
        suffix: "mit",
    },
};

function About() {
    const { language, t } = useTranslation();
    const [currentText, setCurrentText] = useState("compromiso");
    const [currentTextMobile] = useState("meta");
    const mission = missionCopy[language] || missionCopy.es;
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const textKeys = Object.keys((missionCopy[language] || missionCopy.es).desktop);

        // 🔄 Intervalo para cambiar texto cada 6 segundos
        const interval = setInterval(() => {
            setCurrentText((prev) => {
            const currentIndex = textKeys.indexOf(prev);
            return textKeys[(currentIndex + 1) % textKeys.length];
            });
        }, 6000);
        
        // 📱 Detectar si es móvil
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkMobile(); // Verifica al montar
        window.addEventListener("resize", checkMobile);
        
        // 🔄 Cleanup
        return () => {
            clearInterval(interval);
            window.removeEventListener("resize", checkMobile);
        };
    }, [language]);
      
    
    return (
        <div className="about-page">
            <SeoHead
                title="Sobre mi | TheQAHub"
                description="Conoce a Diego Sanchez Martin, fundador de TheQAHub, y su vision para ayudar a testers a crecer en Quality Assurance."
                canonicalPath="/sobre-mi"
            />
            <AboutHero />
            {/* Sección de Waves */}
            <div className="waves-section">
                <Waves 
                    lineColor="#97b79e" 
                    backgroundColor="transparent" 
                    waveSpeedX={0.02}
                    waveSpeedY={0.005}
                    waveAmpX={25}
                    waveAmpY={10}
                    xGap={12}
                    yGap={20}
                    className="custom-waves"
                />
                <p className="waves-text">{t("about.waves")}</p>
            </div>
            <AboutDetails />
            {/* Línea divisoria elegante */}
            <hr className="section-divider" />
            {/* Sección de habilidades */}
            <SkillsSection />
            {/* Línea divisoria elegante */}
            <hr className="section-divider" />
            <>
                {isMobile ? (
                    <section className="about-container">
                        <div className="about-text">
                            <div className="about-mission-heading">
                                <span className="about-section-kicker">Misión TheQAHub</span>
                                <h2 className="mission-text mission-text-mobile section-title-academy">
                                    {mission.prefix} <span className="textRotating mission-text-chip">{mission.mobileLabels[0]}</span> {mission.suffix} <span className="theqahub-font">{"</"}TheQAHub{">"}</span>
                                </h2>
                            </div>
                            <AnimatePresence mode="wait">
                                <motion.div key={`${language}-${currentTextMobile}`} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.5 }} className="mt-4 about-mission-copy">
                                    {mission.mobile[currentTextMobile]}
                                </motion.div>
                            </AnimatePresence>
                        </div>
                        <AboutVideoMission/>
                    </section>
                ) : (
                    <section className="about-container">
                        <AboutVideoMission/>
                        <div className="about-text">
                            <div className="about-mission-heading">
                                <span className="about-section-kicker">Misión TheQAHub</span>
                                <div className="mission-text">
                                    <h2 className="section-title-academy">{mission.prefix}</h2>
                                    <div className="separator"/>
                                    <h2 className="textAbout section-title-academy">
                                        <RotatingText
                                            texts={mission.desktopLabels}
                                            mainClassName="textRotating px-2 sm:px-2 md:px-3 bg-cyan-300 text-black overflow-hidden py-0.5 sm:py-1 md:py-2 justify-center rounded-lg"
                                            staggerFrom={"last"}
                                            initial={{ y: "100%" }}
                                            animate={{ y: 0 }}
                                            exit={{ y: "-120%" }}
                                            staggerDuration={0.025}
                                            splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
                                            transition={{ type: "spring", damping: 30, stiffness: 400 }}
                                            rotationInterval={6000}
                                        />
                                    </h2>
                                    <div className="separator"/>
                                    <h2 className="section-title-academy">{mission.suffix} <span className="theqahub-font">{"</"}TheQAHub{">"}</span></h2>
                                </div>
                            </div>
                            <AnimatePresence mode="wait">
                                <motion.div key={`${language}-${currentText}`} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.5 }} className="mt-4 about-mission-copy">
                                    {mission.desktop[currentText]}
                                </motion.div>
                            </AnimatePresence>
                        </div>
                    </section>
                )}
            </>

            {/* Línea divisoria elegante */}
            <hr className="section-divider" />

            <TimelineComponent />

            {/* Línea divisoria elegante */}
            <hr className="section-divider" />
            
            <section className="connect-cta-section">
                <div className="connect-cta-content">
                    <div className="letters connect-cta-title">
                        {isMobile ? (
                            <h2 className="mobile-connect-title">{t("common.connect")}</h2>
                        ) : (
                            <TextPressure
                                text={t("common.connect")}
                                fontFamily="Bogart"
                                textColor="#5f7868"
                                minFontSize={44}
                                maxFontSize={138}
                                movementIntensity={10}
                                className="connect-pressure-title"
                            />
                        )}
                    </div>
                    <p className="connect-cta-lead">{t("common.connectLead")}</p>
                    <div className="connect-cta-tags" aria-label={t("common.connectTagsLabel")}>
                        <span>{t("common.connectTag1")}</span>
                        <span>{t("common.connectTag2")}</span>
                        <span>{t("common.connectTag3")}</span>
                    </div>
                    <div className="contact-button-border">
                        <div className="contact-button-display">
                            <a href="/contacto" className="contact-button-sections">
                                <GradientText
                                    colors={["#5f7868", "#97b79e", "#5f7868", "#97b79e", "#5f7868"]}
                                    animationSpeed={3}
                                    showBorder={false}
                                    className="custom-class"
                                >
                                    {t("common.contactMe")}
                                </GradientText>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Línea divisoria elegante */}
            <hr className="section-divider-about-me" />
            <ContactInfo/>
        </div>
    );
}

export default About;
